<script>
    export default{
        data(){
            return{
            }
        },
        components:{
        }
    }

</script>
<template>
  <div>
    <el-form-item label="Label">
      <el-upload>
      </el-upload>
    </el-form-item>
  </div>
</template>



// WEBPACK FOOTER //
// SgsRenderInputButtonUpload.vue?5f3eb52d